import {isNil} from 'ramda';

import {precisionCalculation} from 'shared/web';

import {DeliveryNoteItem} from '../types/DeliveryNoteDocumentPreviewFormDefinition';
import {isInvalidDocumentItemNumber} from './isInvalidDocumentItemNumber';

export function hasItemPriceMismatch(
  item: Pick<DeliveryNoteItem, 'quantity' | 'unitPrice' | 'totalPrice'>,
  allowZeroPrices = false
) {
  const {quantity, unitPrice, totalPrice} = item;

  if (
    isNil(quantity) ||
    isInvalidDocumentItemNumber(quantity) ||
    isNil(unitPrice) ||
    isInvalidDocumentItemNumber(unitPrice, allowZeroPrices) ||
    isNil(totalPrice) ||
    isInvalidDocumentItemNumber(totalPrice, allowZeroPrices)
  ) {
    return false;
  }

  const calculatedTotal = precisionCalculation.round(
    precisionCalculation.multiply(quantity, unitPrice),
    2
  );
  if (calculatedTotal === precisionCalculation.round(totalPrice, 2)) {
    return false;
  }

  return (
    quantity === 0 ||
    precisionCalculation.round(precisionCalculation.divide(totalPrice, quantity), 2) !==
      precisionCalculation.round(unitPrice, 2)
  );
}
